import { HOST } from "src/config/urls"

export function formatAttachmentUrl(url: string) {
  return `${HOST}/${url}`
}
